import * as generic from "../generic";

export const createDomain = (...props) => generic.createEntity("domain", ...props);
export const editDomain = (...props) => generic.editEntity("domain", ...props);
export const deleteDomain = (...props) => generic.deleteEntity("domain", ...props);
export const fetchDomains = (...props) => generic.fetchEntityList("domain", ...props);
export const setActiveDomain = id => generic.selectEntity("domain", id);
